import * as React from 'react';
import { TimelineContext } from './types';

export default React.createContext<TimelineContext>({ tracks: [] });
